import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import {store} from './store'

Vue.use(firestorePlugin)
Vue.config.productionTip = false

export const _logout = () => {
  store.commit('logout')
}

Vue.mixin({
  methods: {
    logEvent: (payload) => {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(payload)
    }
  }
})

require('./assets/semantic.min.css')
require('./assets/semantic.min.js')
require('../node_modules/firebaseui/dist/firebaseui.css')

// require('https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.4.1/semantic.min.css')
// require('https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.4.1/semantic.min.js')

const config = {
  apiKey: "AIzaSyCLq-_vBw8x1UOTYs1zjELz_nKBn7JtRYY",
  authDomain: "our-assets.firebaseapp.com",
  databaseURL: "https://our-assets.firebaseio.com",
  projectId: "our-assets",
  storageBucket: "our-assets.appspot.com",
  messagingSenderId: "251649721574",
  appId: "1:251649721574:web:a64552d1bfed9da6c7e727",
  measurementId: "G-0FYNXCG6W0"
};
firebase.initializeApp(config)

const unsubscribe = firebase.auth()
  .onAuthStateChanged(async (firebaseUser) => {
    if (firebaseUser) {
      store.commit('login')

      const where = [['created_by', '==', firebaseUser.uid]]
      const orderBy = ["created_at"]
      const whereShared = [['users', 'array-contains', firebaseUser.uid]]

      let default_account = firebaseUser.uid
      await store.dispatch('AccountModule/openDBChannel', {where}).then(() => {
        let accounts = Object.values(store.state.AccountModule.accounts)
        if (accounts.length > 0 && accounts[0].default_account != "") {
          default_account = accounts[0].default_account
        }

        store.dispatch('AccountModule/openDBChannel', {where: whereShared})//.then(() => {
        //   let shared_accounts = Object.values(store.state.AccountModule.accounts)
        //   for (var i = 0; i < shared_accounts.length; i++) {
        //     // var accountId = shared_accounts[i].id
        //     let dynamicWhere = [['created_by', '==', default_account]]
        //     store.dispatch('ItemModule/openDBChannel', { where: dynamicWhere })
        //     store.dispatch('PhotoModule/openDBChannel', { where: dynamicWhere })
        //   }
        // })

        // let dynamicWhere = [['created_by', '==', default_account]]
        store.dispatch('ItemModule/openDBChannel', { where: [['created_by', '==', default_account],['deleted', '==', false]], orderBy })
        // store.dispatch('ItemModule/openDBChannel')
        store.dispatch('PhotoModule/openDBChannel', { where: [['created_by', '==', default_account]], orderBy })
      })

      // store.dispatch('GalleryModule/openDBChannel', {where})
      // store.dispatch('GalleryModule/openDBChannel', {where: whereShared})
    }

    var main = new Vue({
      el: '#iapp',
      router,
      store,
      render: h => h(App),
      created () {
      }
    })

    unsubscribe()
    return main
  })
